import { z } from 'zod';
import { SanityDocumentSchema, SanityReferenceSchema } from '../sanity';
import { ComponentType } from '$lib/sanity/types';

export const NewsLatestPostsSchema = SanityDocumentSchema.extend({
  _type: z.literal(ComponentType.NewsLatestPosts),
  name: z.string(),
  limit: z.number(),
  tags: z.array(SanityReferenceSchema),
  headlineSize: z.union([
    z.literal('h1'),
    z.literal('h2'),
    z.literal('h3'),
    z.literal('h4'),
    z.literal('h5')
  ]),
  itemId: z.string().optional().nullable()
});

export type NewsLatestPosts = z.infer<typeof NewsLatestPostsSchema>;
